import { AppBar, Box, IconButton, Toolbar, Typography } from '@mui/material';
import { Panel } from 'react-resizable-panels';
import PreviewDRG from '../../../components/PreviewDRG';
import CloseIcon from '@mui/icons-material/Close';

const PreviewPanel = (props) => {
    const { defaultSize, closePanel, statements, onHover, onHoverLeave } = props;
    return (
        <Panel defaultSize={defaultSize || 25}>
            <AppBar position="static" sx={{ height: "25px", boxShadow: 'none', backgroundColor: "whitesmoke" }}>
                <Toolbar disableGutters variant="dense" sx={{ minHeight: '25px', height: '25px', marginLeft: '12px', display: 'flex', justifyContent: 'space-between' }}>
                    <Typography variant='inherit' color='textSecondary'>Preview</Typography>
                    <IconButton
                        aria-label="close console"
                        aria-controls="close-console"
                        onClick={closePanel}
                        color="default"
                        style={{
                            height: '25px',
                            width: '25px',
                            marginRight: '4px'
                        }}
                    >
                        <CloseIcon className='p-0.5' />
                    </IconButton>
                </Toolbar>
            </AppBar>
            <Box className="h-[calc(100%-25px)] border-collapse overflow-auto">
                {statements?.result && (
                    statements?.result?.length > 1 ?
                        statements.result.map((preview, idx) =>
                            <Box key={idx} component="section" sx={{ m: 2, height: "160px", border: '1px dashed grey' }} className='hover:border-blue-600'>
                                <PreviewDRG preview={preview} idx={idx} onHover={onHover} onHoverLeave={onHoverLeave} />
                            </Box>
                        )
                        : <PreviewDRG preview={statements.result[0]} />
                )}
            </Box>
        </Panel>
    );
};

export default PreviewPanel;